export default "__VITE_ASSET__741ba65d__"